 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import BOOKDESCRIPTION from '@/components/bookdescription'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import CONTENTS from '@/components/contents'
 import DEDICATION from '@/components/dedication'
 import INTRODUCTIONTOTODAYIREMEMBER from '@/components/introductiontotodayiremember'
 import TODAYIREMEMBER from '@/components/todayiremember'
 import INTRODUCTIONTOILGRANCAVALLO from '@/components/introductiontoilgrancavallo'
 import ILGRANCAVALLO from '@/components/ilgrancavallo'
 import INTRODUCTIONTOUNREFINED from '@/components/introductiontounrefined'
 import UNREFINED from '@/components/unrefined'
 import INTRODUCTIONTOFATHERDAUGHTEROUTING from '@/components/introductiontofatherdaughterouting'
 import FATHERDAUGHTEROUTING from '@/components/fatherdaughterouting'
 import INTRODUCTIONTOTODAYIAMPAUL from '@/components/introductiontotodayiampaul'
 import TODAYIAMPAUL from '@/components/todayiampaul'
 import INTRODUCTIONTOSCRAMBLE from '@/components/introductiontoscramble'
 import SCRAMBLE from '@/components/scramble'
 import INTRODUCTIONTOTHEVAMPIRESNEWCLOTHES from '@/components/introductiontothevampiresnewclothes'
 import THEVAMPIRESNEWCLOTHES from '@/components/thevampiresnewclothes'
 import INTRODUCTIONTOVIEWFROMAHILL from '@/components/introductiontoviewfromahill'
 import VIEWFROMAHILL from '@/components/viewfromahill'
 import INTRODUCTIONTOTHEMOTHERANTHONY from '@/components/introductiontothemotheranthony'
 import THEMOTHERANTHONY from '@/components/themotheranthony'
 import INTRODUCTIONTOBOOKMARKED from '@/components/introductiontobookmarked'
 import BOOKMARKED from '@/components/bookmarked'
 import INTRODUCTIONTOONELASTCHOREFORGRANDPA from '@/components/introductiontoonelastchoreforgrandpa'
 import ONELASTCHOREFORGRANDPA from '@/components/onelastchoreforgrandpa'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import LOVE_2 from '@/components/love_2'
 import ADDITIONALCOPYRIGHTINFORMATION from '@/components/additionalcopyrightinformation'
 import IFYOULIKED from '@/components/ifyouliked'
 import OTHERWORDFIREPRESSTITLESBYMARTINLSHOEMAKER from '@/components/otherwordfirepresstitlesbymartinlshoemaker'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/bookdescription",
 			"name" : "bookdescription",
 			"component" : BOOKDESCRIPTION
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/introductiontotodayiremember",
 			"name" : "introductiontotodayiremember",
 			"component" : INTRODUCTIONTOTODAYIREMEMBER
 		},
 		{
 			"path" : "/todayiremember",
 			"name" : "todayiremember",
 			"component" : TODAYIREMEMBER
 		},
 		{
 			"path" : "/introductiontoilgrancavallo",
 			"name" : "introductiontoilgrancavallo",
 			"component" : INTRODUCTIONTOILGRANCAVALLO
 		},
 		{
 			"path" : "/ilgrancavallo",
 			"name" : "ilgrancavallo",
 			"component" : ILGRANCAVALLO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js